<template>
    <div class="subnet-detail-container">
        <div class="jc-colude-mask" v-if="descriptionFlag || nameFlag"></div>
        <div class="jc-page-header">
            <el-page-header show-back-icon :title="$t('subnet.text.subnet')" @back="jump_to_up()" class="relative">
                <template slot="content">
                    <span class="long-name" :title="gridData.name">
                        {{ gridData.name }}
                    </span>
                    <div class="jc-list__header--right jc-box-action">
                        <a v-bind:href="Config.SUBNET_URL" target="_blank"> {{ $t('subnet.help.doc') }}</a>
                        <!--操作下拉选-->
                        <drop-down-operation :operations="operates" @clickSelectItem="selectOpts"
                            :buttonTitle="$t('privateNetwork.operate')">
                        </drop-down-operation>
                    </div>
                </template>
            </el-page-header>
        </div>
        <div class="jc-page-content">
            <el-tabs type="border-card" v-model="activeTab">
                <!--资源信息-->
                <el-tab-pane :label="$t('detail.text.sourceInfo')" name="sourceInfo">
                    <!--基本信息-->
                    <div class="jc-section">
                        <div class="jc-section-header">
                            <h3 class="jc-section-title">{{ $t('detail.text.baseInfo') }}</h3>
                        </div>
                        <div class="jc-section-content">
                            <el-form class="jc-datashow-list jc-datashow-list-inline align-left" :model="editObj"
                                ref="editObj" :rules="rules" @submit.native.prevent>
                                <el-row :gutter="20">
                                    <!--ID-->
                                    <el-col :span="8">
                                        <el-form-item :label="$t('detail.text.id') | withColon">
                                            <p>
                                                <span>{{ gridData.subnetId | maybeEmpty }}</span>
                                                <copy-value :copyVal="`${gridData.subnetId}`"></copy-value>
                                                <!-- <span @mouseout="copyHover = false">
                                                    <el-button :disabled="gridData.subnetId === undefined"
                                                        v-clipboard:copy="subnetId" v-clipboard:success="copyToClipboard"
                                                        v-clipboard:error="failToCopy" id="copy-button" type="text"
                                                        icon="el-icon-document-copy"></el-button>
                                                </span> -->
                                            </p>
                                        </el-form-item>
                                    </el-col>
                                    <!--名称-->
                                    <el-col :span="8">
                                        <el-form-item v-if='descriptionFlag' :label="$t('subnet.text.name') | withColon"
                                            class="jc-form-description">
                                            <p>{{ gridData.name }}
                                                <el-button type="text" icon="jc-icon-edit"
                                                    @click="setEdit('name', gridData.name)"
                                                    :disabled="gridData.name === undefined"></el-button>
                                            </p>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item v-if='!descriptionFlag' :label="$t('subnet.text.name') | withColon"
                                            class="jc-form-description" prop="editName" :show-message="false"
                                            ref="editName">
                                            <p>{{ gridData.name }}
                                                <el-button type="text" icon="jc-icon-edit"
                                                    @click="setEdit('name', gridData.name)"
                                                    :disabled="gridData.name === undefined"></el-button>
                                            </p>
                                            <!--编辑名称弹框-->
                                            <div v-if="nameFlag" class="jc-info-description">
                                                <p class="txt">{{ $t('detail.text.modifyName') + ': ' }}</p>
                                                <el-input v-model="editObj.editName" class="edit-pop-diy-dialog"
                                                    @keyup.enter.native="confirmModify('name')"
                                                    :placeholder="$t('detail.placeholder.editName')"
                                                    @focus="ruleFormTag.editName = 0"></el-input>
                                                <p v-if="ruleFormTag.editName !== 0 && editObj.editName == ''"
                                                    class="el-form-item-help-error">{{
                                                        $t('detail.speechCraft.nameNoNull') }}</p>
                                                <p v-if="ruleFormTag.editName === 'error' && editObj.editName !== ''"
                                                    class="el-form-item-help"
                                                    :class="{ 'el-form-item-help-error': this.ruleFormTag.editName == 'error' }">
                                                    {{
                                                        $t('detail.speechCraft.editNameRule') }}</p>
                                                <div class="tright">
                                                    <el-button @click="cancelModify" size="mini" class="edit-footer-button">
                                                        {{ $t('detail.text.cancel') }}
                                                    </el-button>
                                                    <el-button @click="confirmModify('name')" type="primary" size="mini"
                                                        class="edit-footer-button">{{ $t('detail.text.sure') }}
                                                    </el-button>
                                                </div>
                                            </div>
                                        </el-form-item>
                                    </el-col>
                                    <!--描述-->
                                    <el-col :span="8">
                                        <el-form-item v-if='nameFlag' :label="$t('detail.text.describe') | withColon"
                                            class="editDescription">
                                            <p v-if="gridData.description" :title="gridData.description" class="desc-span">
                                                {{ gridData.description }}
                                                <el-button type="text" icon="jc-icon-edit"
                                                    @click="setEdit('des', gridData.description)"
                                                    :disabled="gridData.description === undefined"
                                                    class="icon-position"></el-button>
                                            </p>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item v-if='!nameFlag' :label="$t('detail.text.describe') | withColon"
                                            class="editDescription" :show-message="false" ref="editDescription"
                                            prop="editDescription">
                                            <p class="desc-span">{{ gridData.description }}
                                                <el-button type="text" icon="jc-icon-edit"
                                                    @click="setEdit('des', gridData.description)"
                                                    :disabled="gridData.description === undefined"
                                                    class="icon-position"></el-button>
                                            </p>
                                            <!--编辑描述弹框-->
                                            <div v-if="descriptionFlag" class="jc-info-description">
                                                <p class="txt">{{ $t('detail.text.modifyDescribe') + ': ' }}</p>
                                                <el-input @keyup.enter.native="confirmModify('des')" type="textarea"
                                                    class="edit-pop-textarea" :rows="4" v-model="editObj.editDescription"
                                                    placeholder=""></el-input>
                                                <p v-if="ruleFormTag.editDescription == 'error'" class="el-form-item-help"
                                                    :class="{
                                                        'el-form-item-help-error':
                                                            this.ruleFormTag.editDescription == 'error'
                                                    }">
                                                    {{ $t('detail.speechCraft.descriptionLongRule') }}</p>
                                                <div class="tright">
                                                    <el-button size="mini" class="edit-footer-button" @click="cancelModify">
                                                        {{ $t('detail.text.cancel') }}</el-button>
                                                    <el-button type="primary" size="mini" class="edit-footer-button"
                                                        @click="confirmModify('des')">{{
                                                            $t('detail.text.sure')
                                                        }}</el-button>
                                                </div>
                                            </div>
                                            <div class="jc-colude-mask" v-if="descriptionFlag"></div>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <!--地域-->
                                        <el-form-item :label="$t('detail.text.region') | withColon">
                                            <p>{{ regions[region] |
                                                maybeEmpty }}</p>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <!--可用区-->
                                        <el-form-item :label="$t('detail.text.availableArea') | withColon">
                                            <p>{{ azMap[gridData.az] | maybeEmpty }}</p>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <!--创建时间-->
                                        <el-form-item :label="$t('detail.text.createTime') | withColon">
                                            <p>{{ gridData.createTime | maybeEmpty }}</p>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form>
                        </div>
                    </div>
                    <el-divider></el-divider>
                    <!--配置信息-->
                    <div class="jc-section">
                        <div class="jc-section-header">
                            <h3 class="jc-section-title">{{ $t('detail.text.configurationInfo') }}</h3>
                        </div>
                        <div class="jc-section-content">
                            <el-form class="jc-datashow-list jc-datashow-list-inline">
                                <el-row :gutter="20">
                                    <!--所属网络-->
                                    <el-col :span="8">
                                        <el-form-item :label="$t('subnet.text.netBelongTo') | withColon">
                                            <a href="javascript:void(0)"
                                                @click="jumpToVpcDetail(gridData.vpcName, 'source')">{{ gridData.vpcName |
                                                    maybeEmpty }}</a>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <!--主要ipv4 CIDR-->
                                        <el-form-item :label="$t('subnet.text.cidr') | withColon">
                                            <p class="english-word-wrap">{{ gridData.cidr | maybeEmpty }}</p>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <!--主要ipv6 CIDR-->
                                        <el-form-item :label="$t('subnet.text.primaryIpv6Cidr') | withColon">
                                            <p class="english-word-wrap">{{ gridData.ipv6Cidr | maybeEmpty }}</p>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <!--可用IPv4/总IPv4-->
                                        <el-form-item :label="$t('subnet.text.availableIpToAllIp') | withColon">
                                            <p>{{ gridData.availableIpToAllIp | maybeEmpty }}</p>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <!--可用IPv6/总IPv6-->
                                        <el-form-item :label="$t('subnet.text.availableIpv6ToAllIp') | withColon">
                                            <p>{{ gridData.availableIpToAllIpv6 | maybeEmpty }}</p>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <!--次要ipv4 CIDR-->
                                        <el-form-item :label="$t('subnet.text.subCidr') | withColon">
                                            <p class="english-word-wrap">{{ gridData.secondaryCidr | maybeEmpty }}</p>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form>
                        </div>
                    </div>
                    <el-divider></el-divider>
                    <!--已分配别名IP范围-->
                    <div class="jc-section">
                        <div class="jc-section-header">
                            <h3 class="jc-section-title">{{ $t('subnet.text.alreadyAllocateIpAliasRange') }}</h3>
                        </div>
                        <div class="jc-section-content">
                            <el-table class="jc-datashow-list jc-datashow-list-inline" :data="aliasIpsListData"
                                v-loading="aliasTableListLoading">
                                <!--别名IP范围-->
                                <el-table-column :label="$t('subnet.text.ipAliasRange')" prop="cidr">
                                    <template slot-scope="scope">
                                        <span>{{ scope.row.cidr | maybeEmpty }}</span>
                                    </template>
                                </el-table-column>
                                <!--分配来源-->
                                <el-table-column :label="$t('subnet.text.allocacateSource')" prop="source">
                                    <template slot-scope="scope">
                                        <p class="english-word-wrap">
                                            {{ computedAllocacateSource(scope) | maybeEmpty }}
                                        </p>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                </el-tab-pane>
                <!--云物理服务器-->
                <el-tab-pane :label="$t('listPage.speechCraft.title')" name="cps">
                    <el-table v-bind:data="subnetInstanceListData" class="subnet-instance-list-table"
                        v-loading="tableListLoading">
                        <!--名称-->
                        <el-table-column prop="name" :label="$t('subnet.text.name')" width="300">
                            <template slot-scope="scope">
                                <a href="javascript:void(0)"
                                    @click="jumpToVpcInstanceDetail(scope.row.instanceId, scope.row.region, scope.row.az, scope.row.sn)">
                                    {{ scope.row.name | maybeEmpty }}</a>
                            </template>
                        </el-table-column>
                        <!--内网IP-->
                        <el-table-column prop="baseInfo" :label="$t('subnet.text.privateIp')" width="500">
                            <template slot-scope="scope">
                                <span>{{ scope.row.privateIp + $t('listPage.text.privateIpv4') }}</span>
                                <p v-if="scope.row.ipv6Address">{{ scope.row.ipv6Address +
                                    $t('privateNetInstance.ipv6Address') }}</p>
                                <p v-else>{{ '--' + $t('privateNetInstance.ipv6Address') }}</p>
                            </template>
                        </el-table-column>
                        <!--创建时间-->
                        <el-table-column prop="status" :label="$t('detail.text.createTime')">
                            <template slot-scope="scope">
                                <span>{{ scope.row.charge ? scope.row.charge.chargeStartTime : '' | maybeEmpty }}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-tab-pane>
                <!--次要CIDR-->
                <el-tab-pane :label="$t('subnet.text.subCidr')" name="subCidr">
                    <!--同一子网下仅支持创建一个次要CIDR-->
                    <el-tooltip :disabled="subCidrTableListData.length < 1" placement="right" effect="dark">
                        <span>
                            <el-button type="primary" @click='openSubCidrAddDialog' class="add-sub-cidr"
                                :disabled="subCidrTableListData.length >= 1">
                                {{ $t('subnet.text.addSubCidr') }}
                            </el-button>
                        </span>
                        <div slot="content" class="my-create-tip">{{ $t('subnet.help.onlyOneSubCidr') }}</div>
                    </el-tooltip>
                    <el-table :data="subCidrTableListData" class="subnet-instance-list-table"
                        v-loading="subCidrTableListLoading">
                        <!--次要CIDR名称-->
                        <el-table-column prop="name" :label="$t('subnet.text.subCidrName')" width="200">
                            <template slot-scope="scope">
                                <span>
                                    {{ scope.row.name | maybeEmpty }}
                                </span>
                            </template>
                        </el-table-column>
                        <!--CIDR类型-->
                        <el-table-column prop="protocol" :label="$t('subnet.text.cidrType')" width="200">
                            <template slot-scope="scope">
                                <span>{{ scope.row.protocol | maybeEmpty }}</span>
                            </template>
                        </el-table-column>
                        <!--CIDR地址-->
                        <el-table-column prop="baseInfo" :label="$t('subnet.text.cidrAddress')" width="200">
                            <template slot-scope="scope">
                                <span>{{ scope.row.cidr | maybeEmpty }}</span>
                            </template>
                        </el-table-column>
                        <!--所属网络-->
                        <el-table-column prop="status" :label="$t('subnet.text.netBelongTo')">
                            <template slot-scope="scope">
                                <span>{{ scope.row.vpcName + '(' + scope.row.vpcCidr + ')' | formatEmptyFilter }}</span>
                            </template>
                        </el-table-column>
                        <!--可用IP/总IP（次）-->
                        <el-table-column prop="status" :label="$t('subnet.text.availableIpToAllIpSub')">
                            <template slot-scope="scope">
                                <span>{{ scope.row.availableIpCount + '/' + scope.row.totalIpCount | formatEmptyFilter }}
                                </span>
                            </template>
                        </el-table-column>
                        <!--操作-->
                        <el-table-column prop="status" :label="$t('listPage.tableLabel.operation')">
                            <template slot-scope="scope">
                                <el-tooltip v-if="scope.row.availableIpCount < scope.row.totalIpCount"
                                    :content="$t('subnet.help.usedDeleteNotAllowed')">
                                    <span :class="[{ 'a-disabled': scope.row.availableIpCount < scope.row.totalIpCount }]">
                                        {{ $t('subnet.text.delete') }}</span>
                                </el-tooltip>
                                <a v-else href="javascript:void(0)" @click="subCidrSelectOperations(SubnetOperationConstant.DELETE,
                                    scope.row, scope.row.availableIpCount < scope.row.totalIpCount)">
                                    {{ $t('subnet.text.delete') }}
                                </a>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-tab-pane>
                <div v-if="activeTab === 'cps' && total > 0" ref="footer"
                    class="jc-page-footer-detail block jc-container-table-actionBar">
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="currentPage" :page-sizes="pageSizes" :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper" :total="total">
                    </el-pagination>
                </div>
            </el-tabs>
        </div>
        <div v-if="copyHover" class="jc-tooltip__popper is-dark copy-success" x-placement="bottom">
            {{ $t('detail.text.copySuccess') }}
            <div class="popper__arrow copy-success-arrow"></div>
        </div>
        <ipv6-subnet :ipv6-dialog-visible="ipv6DialogVisible" :currentRow="gridData" :region="region"
            @ifIpv6DialogVisible="syncIpv6DialogVisibleData" @refreshList="getServerData" v-if="ipv6DialogVisible">
        </ipv6-subnet>
        <add-sub-cidr :dialog-visible.sync="addSubCidrDialogVisible" :detail-data="gridData"
            @refreshSubCidrListData="refreshSubCidrRelation">
        </add-sub-cidr>
    </div>
</template>

<script>
import { SubnetOperationConstant, NetworkTypeConstant } from '@/common/Constants';
import ipv6Subnet from '@/components/subnet/ipv6Subnet/ipv6Subnet';
import AddSubCidr from '@/components/subnet/addSubCidr/AddSubCidr';
import { SubCidrOperations } from '@/common/SubCidrHelper';
import dropDownOperation from '@/components/privateNetInstance/dropdownOperation/DropdownOperation';
import copyValue from '@/components/privateNetwork/CopyValue';

export default {
    components: {
        ipv6Subnet,
        AddSubCidr,
        dropDownOperation,
        copyValue
    },
    data() {
        const validateLength = (rule, value, callback) => {
            if (value.length > 256) {
                callback(new Error());
            } else {
                callback();
            }
        };
        const validateName = (rule, value, callback) => {
            const reg = new RegExp('^[-0-9a-zA-Z_\\u4e00-\\u9fa5]{1,32}$');
            if (!reg.test(value)) {
                callback(new Error());
            } else {
                callback();
            }
        };
        return {
            clientToken: Normal.getClientToken(),
            subnetId: '',
            ipv6DialogVisible: false,
            // 支持的操作
            operatesArr: [
                'DELETE',
                'ENABLEIPV6'
            ],
            // 存储region和regionName
            regions: {},
            selectOperate: '1',
            gridData: {},
            descriptionFlag: false,
            editObj: {
                editName: '',
                editDescription: ''
            },
            nameFlag: false,
            rules: {
                editName: [
                    { validator: validateName }
                ],
                editDescription: [
                    { validator: validateLength }
                ],
            },
            ruleFormTag: {
                editName: 0,
                editDescription: 0,
            },
            region: '',
            azMap: {
                'cn-east-1a': this.$t('detail.text["cn-east-1a"]'),
                'cn-north-1b': this.$t('detail.text["cn-north-1b"]'),
                'cn-north-1a': this.$t('detail.text["cn-north-1a"]'),
                'cn-north-1c': this.$t('detail.text["cn-north-1c"]'),
            },
            copyHover: false,
            // 子网对应的云物理服务器列表
            subnetInstanceListData: [],
            // 云物理服务器tab页loading状态
            tableListLoading: false,
            // 云物理服务器个数
            total: 0,
            pageSize: 20,
            pageSizes: [20, 50, 100], // 可选每页展示多少条
            currentPage: 1,
            activeTab: 'sourceInfo',
            // 别名IP列表loading状态
            aliasTableListLoading: false,
            // 别名IP列表数据
            aliasIpsListData: [],
            // 次要CIDR列表loading状态
            subCidrTableListLoading: false,
            // 次要CIDR列表数据
            subCidrTableListData: [],
            // 添加次要CIDR弹框是否显示
            addSubCidrDialogVisible: false,
            //下拉框选项
            operates: []
        };
    },
    computed: {
        SubnetOperationConstant: () => SubnetOperationConstant,
        computedAllocacateSource() {
            return function (scope) {
                if (scope.row.ipv6Cidr) {
                    return `${this.$t('subnet.text.primaryIpv6Cidr')}(${scope.row.primaryCidr})`;
                } else {
                    if (scope.row.primaryName) {
                        return `${scope.row.primaryName}(${scope.row.primaryCidr})`;
                    }
                    if (scope.row.secondaryCidr) {
                        return `${this.$t('subnet.text.subCidr')}(${scope.row.secondaryCidr})`;
                    }
                    return `${this.$t('subnet.text.cidr')}(${scope.row.primaryCidr})`;
                }

            };
        },
    },

    async mounted() {
        this.subnetId = this.$route.query.id;
        this.region = this.$route.query.region;
        this.az = this.$route.query.az;
        await this.getRegions();
        // 获取资源信息tab页数据
        this.getServerData(true);
        // 获取已分配别名IP范围列表
        this.getAliasIpsList();
        // 获取次要CIDR列表tab页数据
        this.getSubCidrsList();
        // 获取云物理服务器tab页数据
        this.getInstancesListForSubnetId();
    },
    methods: {
        /**
            * 获得region和regionName对照
        */
        getRegions() {
            const params = {
                networkType: NetworkTypeConstant.VPC
            };
            return Ajax.get('api/cps/getRegions', params).then((res) => {
                if (res.data) {
                    this.regions = res.data.regions.reduce((init, curr) => {
                        init[curr.region] = curr.regionName;
                        return init
                    }, {});
                }
            });
        },
        syncIpv6DialogVisibleData(data) {
            this.ipv6DialogVisible = data;
        },
        // 打开开通ipv6弹框
        openIpv6() {
            this.ipv6DialogVisible = true;
        },
        setEdit(type, data) {
            if (type === 'name') {
                this.nameFlag = true;
                this.ruleFormTag.editName = 0;
                this.editObj.editName = data;
                setTimeout(() => {
                    try {
                        $('.jc-form-name-input input').focus();
                    } catch (e) {
                    }
                }, 200);
            } else {
                this.descriptionFlag = true;
                this.ruleFormTag.editDescription = 0;
                this.editObj.editDescription = $.trim(data);
            }
        },
        // 取消编辑名称或者描述
        cancelModify() {
            this.editObj.editName = '';
            this.editObj.editDescription = '';
            this.descriptionFlag = false;
            this.nameFlag = false;
            if (this.$refs.editDescription !== undefined) {
                this.$refs.editDescription.resetField();
            }
            if (this.$refs.editName !== undefined) {
                this.$refs.editName.resetField();
            }
        },
        getServerData() {
            const target = this;
            const params = {
                region: target.region,
                subnetId: target.subnetId,
                az: target.az,
            };
            Ajax.get('/api/cps/subnets', params)
                .then((res) => {
                    const subnetDetail = res.data.subnet;
                    this.gridData = subnetDetail;
                    /** 格式化可用IPv4/总IPv4* */
                    this.gridData.availableIpToAllIp = `${subnetDetail.availableIpCount}/${subnetDetail.totalIpCount}`;
                    /** 格式化可用IPv6/总IPv6* */
                    if (subnetDetail.totalIpv6IpCount) {
                        this.gridData.availableIpToAllIpv6 = `${subnetDetail.usedIpv6IpCount}/${subnetDetail.totalIpv6IpCount}`;
                    }
                    this.region = subnetDetail.region;
                    // 初始化可操作下拉列表
                    this.initOperates();
                });
        },
        // 获取当前子网下对应的云物理服务器列表
        getInstancesListForSubnetId() {
            this.tableListLoading = true;
            const param = {
                region: this.region,
                pageNumber: this.currentPage,
                pageSize: this.pageSize,
                subnetId: this.$route.query.id,
                networkType: NetworkTypeConstant.VPC
            };
            Ajax.get('/api/cps/listInstances', param)
                .then((res) => {
                    const data = res.data;
                    this.tableListLoading = false;
                    const list = data.instances;
                    if (list) {
                        this.subnetInstanceListData = list;
                        // 这个total可以用来判断子网下是否有资源，和availableIpCount<totalIpCount一样
                        this.total = data.totalCount;
                    }
                })
                .finally(() => {
                    this.tableListLoading = false;
                });
        },
        // 操作下拉选初始化，目前只有删除
        initOperates() {
            const target = this;
            this.operates = this.operatesArr.map((key) => {
                const { name, tip } = this.$t(`subnet.operations.${key.toLowerCase()}`);
                let item;
                if (key === 'ENABLEIPV6') {
                    if (!this.gridData.ipv6Cidr && this.gridData.vpcIpv6Cidr) {
                        item = {
                            value: SubnetOperationConstant[key],
                            operateName: name,
                            disabled: false
                        };
                    }
                } else if (key === 'DELETE') {
                    if (this.gridData.name.indexOf('Default-Game') === -1) {
                        item = {
                            value: SubnetOperationConstant[key],
                            operateName: name,
                            tip,
                            disabled: target.gridData.availableIpCount < target.gridData.totalIpCount
                        };
                    } else {
                        item = {
                            value: SubnetOperationConstant[key],
                            operateName: name,
                            tip: this.$t('game.tips.deleteVpc'),
                            disabled: true
                        };
                    }
                }
                return item;
            }).filter(item => item);
        },
        jump_to_up() {
            this.$router.push({
                name: 'SubnetList',
                params: { region: this.region }
            });
        },
        // 更多中的操作
        selectOpts(item) {
            const operateValue = item;
            switch (item) {
                case 1: {
                    SubnetPopHelper.operations(SubnetOperationConstant.DELETE, this, this.gridData, 'detail');
                    break;
                }
                case 2: {
                    this.openIpv6();
                    break;
                }
            }
        },
        // 次要CIDR操作
        subCidrSelectOperations(optCase, row, disabled) {
            if (disabled) {
                return false;
            }
            SubCidrOperations(optCase, this, row);
        },
        updateServerData() {
            this.clientToken = Normal.getClientToken();
            this.getServerData(false);
        },
        refreshSubCidrRelation() {
            // 获取资源信息tab页数据
            this.getServerData();
            // 获取次要CIDR列表tab页数据
            this.getSubCidrsList();
        },
        copyToClipboard() {
            this.copyHover = true;
        },
        failToCopy() {
            console.log('Failed to copy texts');
        },
        /**
                * 用于修改某个信息项，弹出对话框并确认
                * @param {string} type - 信息项对应的类别
                */
        confirmModify(type) {
            this.$refs.editObj.validate(async (valid) => {
                // validate fail
                if (!valid) {
                    if (type === 'name' && this.$refs.editName.validateState === 'error') {
                        this.ruleFormTag.editName = this.$refs.editName.validateState;
                        return;
                    }
                    if (type === 'des' && this.$refs.editDescription.validateState === 'error') {
                        this.ruleFormTag.editDescription = this.$refs.editDescription.validateState;
                        return;
                    }
                }

                // validate succ
                switch (type) {
                    case 'name': // 修改 实例名称
                        {
                            if (this.editObj.editName === this.gridData.name) {
                                this.nameFlag = false;
                                return;
                            }
                            const nameRes = await Ajax.post('/api/cps/subnets', {
                                subnetId: this.gridData.subnetId,
                                region: this.gridData.region,
                                name: this.editObj.editName
                            })
                                .catch(async (err) => {
                                    const { response } = err.data;
                                    try {
                                        const json = await response.json();
                                        this.$message.error(json.errmsg);
                                    } catch (ex) {
                                        console.log(ex);
                                    }
                                });
                            this.gridData.name = nameRes.data.subnet.name;
                            this.nameFlag = false;
                            break;
                        }
                    case 'des': // 修改 描述
                    default: {
                        if (this.editObj.editDescription === this.gridData.description) {
                            this.descriptionFlag = false;
                            return;
                        }
                        const desRes = await Ajax.post('/api/cps/subnets', {
                            subnetId: this.gridData.subnetId,
                            region: this.gridData.region,
                            description: this.editObj.editDescription
                        });
                        this.gridData.description = desRes.data.subnet.description;
                        this.descriptionFlag = false;
                        break;
                    }
                }
                if (typeof this.$refs.editDescription !== 'undefined') {
                    this.$refs.editDescription.resetField();
                }
            });
        },
        // 跳转到VPC详情页
        jumpToVpcDetail(vpcName, tabName) {
            this.$router.push({
                path: '/vpc/detail',
                query: {
                    region: this.gridData.region,
                    vpcName,
                    tabName,
                    id: this.gridData.vpcId
                }
            });
        },
        // 跳转到VPC实例详情页
        jumpToVpcInstanceDetail(id, region, az, sn) {
            this.$router.push({
                path: '/instance/vpc/detail',
                query: {
                    id,
                    region,
                    az,
                    sn,
                    azName: this.azMap[az],
                    regionName: this.regions[region],
                    tabName: 'sourceInfo'
                }
            });
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.currentPage = 1;
            this.getInstancesListForSubnetId();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getInstancesListForSubnetId();
        },

        // 查询别名IP列表
        getAliasIpsList() {
            this.aliasTableListLoading = true;
            const param = {
                region: this.region,
                pageNumber: 1,
                pageSize: 200,
                scope: 'all',
                subnetId: this.$route.query.id,
            };
            Ajax.get('/api/cps/listAliasIps', param)
                .then((res) => {
                    const data = res.data;
                    this.aliasTableListLoading = false;
                    const list = data.aliasIps;
                    if (list) {
                        this.aliasIpsListData = list;
                    }
                })
                .finally(() => {
                    this.aliasTableListLoading = false;
                });
        },

        // 查询次要CIDR列表
        getSubCidrsList() {
            this.subCidrTableListLoading = true;
            const param = {
                region: this.region,
                subnetId: this.$route.query.id,
            };
            Ajax.get('/api/cps/listSecondaryCidrs', param)
                .then((res) => {
                    const data = res.data;
                    this.subCidrTableListLoading = false;
                    const list = data.secondaryCidrs;
                    if (list) {
                        this.subCidrTableListData = list;
                    }
                })
                .finally(() => {
                    this.subCidrTableListLoading = false;
                });
        },
        // 打开添加次要CIDR弹框
        openSubCidrAddDialog() {
            this.addSubCidrDialogVisible = true;
        }
    }
};
</script>

<style lang="scss">
@import '~@/assets/scss/detailCommon.scss';
@import 'style';
</style>



// WEBPACK FOOTER //
// src/views/subnet/detail/Detail.vue